import { render } from "./SuppliersTable.vue?vue&type=template&id=754c1ed4&scoped=true"
import script from "./SuppliersTable.vue?vue&type=script&lang=js"
export * from "./SuppliersTable.vue?vue&type=script&lang=js"

import "./SuppliersTable.vue?vue&type=style&index=0&id=754c1ed4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754c1ed4"]])

export default __exports__